<template>
  <b-modal id="rewardSummaryModal"
           title="Reward History"
           :ok-only="true"
           ok-title="Close"
           size="lg"
           :lazy="true"
  >
    <div class="point-box">
      <h2>Total Points Activity</h2>
      <table class="table">
        <thead>
          <td class="th-title">Name</td>
          <td class="th-title">Point</td>
        </thead>
        <tr>
          <td>Points Balance as of {{ new Date() | formatDate('MMM Do YY')}}</td>
          <td>{{point.AvailablePoints | numberFormat('', 0)}}</td>
        </tr>
        <tr>
          <td>Earned</td>
          <td>{{point.EarnedPoints | numberFormat('', 0)}}</td>
        </tr>
        <tr>
          <td>Used</td>
          <td>{{point.RedeemedPoints | numberFormat('', 0)}}</td>
        </tr>
        <tr>
          <td>Total Availabel Points</td>
          <td>{{point.AvailablePoints | numberFormat('', 0)}}</td>
        </tr>
      </table>
    </div>

    <h2>Redemption History</h2>

    <div class="table-box">
      <table class="table">
        <thead>
        <td class="th-title">Order Number</td>
        <td class="th-title">Redemption Date</td>
        <td class="th-title">Consumed Points</td>
        </thead>

        <tr v-for="item of histories">
          <td>{{item.RedeemDesc}}</td>
          <td>{{item.RedeemDate | formatDate}}</td>
          <td>{{item.RequiredPoint}}</td>
        </tr>
      </table>
    </div>

  </b-modal>

</template>

<script>
  export default {
    components: {
    },
    created () {

    },
    data () {
      return {

      }
    },
    computed: {
      histories () {
        return this.$store.state.reward.histories
      },
      point () {
        return this.$store.state.reward.point
      }
    },
    watch: {
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">
.table {
  border: 1px solid #ccc;

}
.table-box {
  max-height: 300px;
  overflow-y: auto;
}
.point-box {
  margin-bottom: 24px;
}
</style>




// WEBPACK FOOTER //
// src/components/reward/MRewardSummary.vue